<template>
<div class="popup" v-show="taskMultiShow" v-cloak id="transferMulti">
    <div id="sourceSelect" class="content">
        <div class="title">
            <span>{{$t('language.popup.cloudTransferPopup.pleaSelect')}}</span>
            <div class="icon white-close dialog-close" @click.stop="taskMultiClose"></div>
        </div>
        <div class="task-content" id="tree-app" ref="sourceTree" v-loading='loading'>
             <el-scrollbar style="height:100%;" ref="elscrollbar">
            <div v-if="!realTimeMode">
            <div v-if="!model.length&&!loading" class="nondrive-des" @click="toAddCloudPage()">
                {{$t('language.popup.cloudTransferPopup.addValidCloud')}}
            </div>
            </div>
            <div v-else>
                 <div v-if="!model.length&&!loading" class='real-nodrives'  @click="toAddCloudPage()">
                 <div class="nondrive-realtime"></div>
                 <div class="nondrive-realtimedes">
                    {{$t('language.popup.cloudTransferPopup.addValidCloud')}}
                 </div>
                 </div>
            </div>
            <el-tree  lazy :load="loadNode" :data="model" ref="tree"   :props="defaultProps" :check-on-click-node=false node-key="keyId"   :show-checkbox=true :expand-on-click-node=true  highlight-current :check-strictly=true @check-change="changeCheckStatus">
                <span slot-scope="{node,data}" style="width:85%;" v-if="openPanel" v-cloak>
                    <div class="tree-icon-position" :class="[data.appName?returnName(data.appName):'small-file',data.dir?matchfolderType(data.docType)+'-small folder-option-icon':'',!data.dir&&!data.appName?matchfileType(data.name)+'-small folder-option-icon':'']"></div>
                    <div class="node-name" :title="node.label">{{node.label|ellipsis}}</div>
                    <!-- <div class="tree-refresh tree-refresh-position" v-if="judgeShow(data)" ></div> -->
                </span>

            </el-tree>
             </el-scrollbar>
        </div>
        <div class="task-footer">
            <button class="task-button" @click.stop="multiSubmit()">{{$t('language.common.ok')}}</button>
        </div>
    </div>
</div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import taskTransferUtils from '@/js/workspace/task_transfer_util.js';
import commonstate from '@/js/constant.js';
export default {
    data: function () {
        return {
            openPanel:true,
            taskMultiShow: false,
            model: [],
            parentFlage: true,
            checkedId: [],
            defaultProps: {
                children: "children",
                label: "name",
                isLeaf: 'leaf'
            },
            checkedNodes: '',
            loading: true,
            flag: true,
            scrollTopValue: 0,
            treeClickCount:0,
            nodeDataFlag:false,
            realTimeMode:true
        };
    },
    mounted() {
        this.loading = true;
        let that = this;
        this.model = Object.assign([], this.$store.getters.getUsersDrives).filter(cloud => !commonstate.emailClouds.includes(cloud.driveType));
        if (!this.model.length&&(that.$route.name == 'cloudTransfer'||that.$route.name=='cloudBackup'||(that.$route.name=='shareTransfer'&&commonUtils.getUser()))) {
            this.model = this.Utils.getAllCloudsList(function (res) {
                if (res.status == 200) {
                    that.model = that.model.filter(cloud => !commonstate.emailClouds.includes(cloud.driveType))
                    that.loading = false;
                }
            });
        } else {
            this.loading = false;
        }
    },
    methods: {
        handleNodeClick(data, node,sel) {
		//记录点击次数
		this.treeClickCount++;
		//单次点击次数超过2次不作处理,直接返回,也可以拓展成多击事件
		if (this.treeClickCount >= 2) {
			return;
		}
		//计时器,计算300毫秒为单位,可自行修改
		this.timer = window.setTimeout(() => {
			if (this.treeClickCount == 1) {
				//把次数归零
				this.treeClickCount = 0;
			} else if (this.treeClickCount > 1) {
				//把次数归零
				this.treeClickCount = 0;
                //双击事件
               // this.loadPageData(data, node,sel);
			}
		}, 300);
        },
        //用户双击加载数据或者用户点击刷新按钮加载分页数据
        // loadPageData(data, node,sel){
        //      let driveId;
        //     let fileId;
        //     let driveType;
        //     let that = this;
        //     let fileArr = [];
        //     if(!data.haveLoad){
        //     if (node.level) {
        //         if (node.level == 1) {
        //             fileId = node.data.rootId;
        //             driveId = node.data.id;
        //             driveType = node.data.appName;
        //             this.$store.commit('setTreeDriveId', driveId);
        //         } else {
        //             driveId = this.$store.state.treeDriveId;
        //             fileId = node.data.id;
        //             driveType = node.data.driveType;
        //         }
        //         let listData = {
        //             ud: JSON.parse(localStorage.getItem("user")).id,
        //             dd: driveId,
        //             id: fileId
        //         }
        //         that.$forceUpdate();
        //         that.Utils.doFilesRequest("list", listData).then(res => {
        //             if (res.status == 200) {
        //                 node.data.haveLoad=true;//表明该数据已经被加载过
        //                 if(node.data.nextPage){
        //                     node.data.oldPage=node.data.nextPage;
        //                 }
        //                 if(res.nextPage){
        //                     node.data.nextPage=res.nextPage;
        //                 }else{
        //                     node.data.nextPage=null;
        //                 }
        //                 if (res.items.length) {
        //                     for (let i = 0; i < res.items.length; i++) {
        //                         res.items[i].driveId = driveId;
        //                         res.items[i].pid = fileId;
        //                         res.items[i].keyId = driveId + res.items[i].id;
        //                         res.items[i].driveType = driveType;
        //                         res.items[i].pnode = node;
        //                         if (!res.items[i].dir) {
        //                             res.items[i].leaf = true;
        //                         } else {
        //                             res.items[i].leaf = false;
        //                         }
        //                         if (this.$store.state.transferFromOpen) {
        //                             fileArr.push(res.items[i]);
        //                         } else if (res.items[i].dir) {
        //                             fileArr.push(res.items[i]);
        //                         }
        //                     }
        //                 } else {
        //                     node.data.leaf = true;
        //                 }
        //                 node.data.children = commonUtils.sortArr(fileArr, true, 0);
        //                 that.openPanel=false;//刷新node数据
        //                 that.openPanel = true;
        //                 fileArr=commonUtils.sortArr(fileArr, true, 0);
        //                 //将新返回的数据插入到tree中
        //                 this.$refs.tree.append(fileArr,node);
        //                 that.$nextTick(function () {
        //                     if (node.checked) {
        //                         that.changeCheckStatus(node.data, true)
        //                     }
        //                 });
        //                  that.$forceUpdate();
        //             } else {
        //                 this.$toast({
        //                     text: this.$t('language.exception.' + res.reason),
        //                     type: 'fail',
        //                     idValue: "sourceSelect"
        //                 });
        //             }
        //         });
        //     }
        //     }
        // },
        returnName(appName){
         let result;
         if(appName!='ownCloud'){
             result='icon '+appName+'-small drive-option-icon';
         }else{
             result='icon '+appName+'-small-box drive-option-icon';
         }
         return result;
        },
        taskMultiClose() {
            let that=this;
             that.taskMultiShow = false;
            if (!this.$refs.tree.getCheckedNodes().length || !this.$parent.mulitDrives.length) {
                for (var i = 0; i < this.$refs.tree.store._getAllNodes().length; i++) {
                    this.$refs.tree.store._getAllNodes()[i].expanded = false;
                }
                this.scrollTopValue = 0;
            }
        },
        refresh(){
          this.$forceUpdate();
        },
        toAddCloudPage() {
            let dom;
            let that = this;
            $.each(that.$parent.$parent.$children, function (i, item) {
                if (item.menuOptions) {
                    dom = that.$parent.$parent.$children[i];
                    dom.menuOptionSelect(10);
                    return;
                }
            });
        },
        multiSubmit() {
            let that = this;
            let res = this.$refs.tree.getCheckedNodes();
            let allArr = this.deleteFatherChildren(res);
            let allNodes = this.getAllNodesPathType(allArr);
            let sourceCatalogArr = [];
            let pKey;
            //判断路径是否重复 且源目录的id不能是父目录的父id
            if (allNodes.length && that.$route.name=='cloudTransfer' && that.$parent.singleDrives.cloudCatalog ) {
                for (let i = 0; i < allNodes.length; i++) {
                    pKey = allNodes[i].keyId + allNodes[i].formUrl;
                    sourceCatalogArr.push(pKey);
                }
                let node = this.$store.state.clickItem;
                this.flag = taskTransferUtils.checkCatalog(sourceCatalogArr, node);
                if (this.flag == false) {
                    that.$toast({
                        text: that.$t('language.exception.notBeTheSame'),
                        type: 'fail',
                        idValue: "transferMulti",
                        learnMoreShow: true
                    });
                    return false;
                }
            }
            //判断是源目录和目标目录否相等
            if (this.flag) {
                this.checkedNodes = res;
                if (allNodes.length > 1) {
                    this.$parent.hasSelectItemsMore = true;
                    this.$parent.mulitDrives = allNodes;
                    this.$parent.hasSelectItems = false;
                } else if (allNodes.length == 1) {
                    this.$parent.mulitDrives = allNodes;
                    this.$parent.hasSelectItems = true;
                    this.$parent.hasSelectItemsMore = false;
                } else if (allNodes.length == 0) {
                    this.$parent.mulitDrives = [];
                    this.$parent.hasSelectItems = false;
                    this.$parent.hasSelectItemsMore = false;
                }
                this.taskMultiShow = false;
            }

            this.scrollTopValue = this.$refs.sourceTree.scrollTop;
            this.$refs.sourceTree.scrollTop = 0;
        },
        judgeShow(data){
          let result;
          if(data.dir||data.appName){
              result=true;
          }
          if(data.nextPage&&data.nextPage!=data.oldPage){
             result=true;
          }
          if(!data.nextPage&&data.haveLoad){
             result=false;
          }
          return result;
        },
        loadNode(node, resolve) {
            let driveId;
            let fileId;
            let driveType;
            let that = this;
            let fileArr = [];
            if (node.level) {
                if (node.level == 1) {
                    fileId = node.data.rootId;
                    driveId = node.data.id;
                    driveType = node.data.appName;
                    this.$store.commit('setTreeDriveId', driveId);
                } else {
                    driveId = this.$store.state.treeDriveId;
                    fileId = node.data.id;
                    driveType = node.data.driveType;
                }
                let listData = {
                    ud: JSON.parse(localStorage.getItem("user")).id,
                    dd: driveId,
                    id: fileId
                }
                that.$forceUpdate();
                that.Utils.doFilesRequest("list", listData).then(res => {
                    if (res.status == 200) {
                        node.data.haveLoad=true;//表明该数据已经被加载过
                        if(node.data.nextPage){
                            node.data.oldPage=node.data.nextPage;
                        }
                        if(res.nextPage){
                            node.data.nextPage=res.nextPage;
                        }else{
                            node.data.nextPage=null;
                        }
                        if (res.items.length) {
                            for (let i = 0; i < res.items.length; i++) {
                                res.items[i].driveId = driveId;
                                res.items[i].pid = fileId;
                                res.items[i].keyId = driveId + res.items[i].id;
                                res.items[i].driveType = driveType;
                                res.items[i].pnode = node;
                                res.items[i].cloudType = res.cloudType;
                                if (!res.items[i].dir) {
                                    res.items[i].leaf = true;
                                } else {
                                    res.items[i].leaf = false;
                                }
                                if (this.$store.state.transferFromOpen) {
                                    fileArr.push(res.items[i]);
                                } else if (res.items[i].dir) {
                                    fileArr.push(res.items[i]);
                                }
                            }
                        } else {
                            node.data.leaf = true;
                        }
                        node.data.children = commonUtils.sortArr(fileArr, true, 0);
                         that.openPanel=false;
                         that.openPanel = true;
                        resolve(commonUtils.sortArr(fileArr, true, 0));
                        that.$nextTick(function () {
                            if (node.checked) {
                                that.changeCheckStatus(node.data, true)
                            }
                        });
                         that.$forceUpdate();
                    } else {
                        this.$toast({
                            text: this.$t('language.exception.' + res.reason),
                            type: 'fail',
                            idValue: "sourceSelect"
                        });
                     resolve([]);
                    }
                });
            }
        },
        includes(arr1, arr2) {
            return arr2.every(val => arr1.includes(val));
        },
        //勾选父级目录时子目录应该也被勾选，勾选子目录时,父级目录不被勾选
        changeCheckStatus(data, sel) {
            //当节点选中时，其子节点也全部选中，若子节点全选中，则父节点选中
            if (sel) {
                this.parentFlage = true;
                traverseTree(data).forEach(item => {
                    this.$refs.tree.setChecked(item, true);
                });
                //判断当该节点的父节点下的子节点是否为全选中状态，若是则选中父节点
                if (data.pnode) {
                    let bortherArr = traverseTree(data.pnode.data);
                    bortherArr.splice(0, 1);
                    let checkKeyArr = this.$refs.tree.getCheckedKeys(false);
                    if (this.includes(checkKeyArr, bortherArr)) {
                        this.$refs.tree.setChecked(data.pnode.data.keyId, true);
                    }
                }
                //当父节点取消选中时，子节点也取消被选中
            } else if (data.formUrl && !this.taskMultiShow) {
                this.$refs.tree.setChecked(data.keyId, false);
            } else {
                if (this.parentFlage) { //防止取消时回调函数
                    //当节点取消选中时，其子节点也取消选中
                    traverseTree(data).forEach(item => {
                        this.$refs.tree.setChecked(item, false);
                    });
                }
                //判断当该节点的父节点下的子节点是否取消，父节点取消选中
                if (data.pnode) {
                    let bortherArr = traverseTree(data.pnode.data);
                    bortherArr.splice(0, 1);
                    let checkKeyArr = this.$refs.tree.getCheckedKeys(false);
                    if (!this.includes(checkKeyArr, bortherArr)) {
                        this.$refs.tree.setChecked(data.pnode.data.keyId, false);
                    }
                    this.parentFlage = false;
                }
            }
        },
        getFilePath(nodes) {
            if (nodes == null) return "";
            var filename = nodes.name;
            let nowNode = this.$refs.tree.getNode(nodes.keyId);
            if (nowNode.parent != null) {
                var pNode = this.$refs.tree.getNode(nodes.keyId).parent.data;
            }
            if (pNode.name != null && pNode != undefined) {
                filename = this.getFilePath(pNode) + '\\' + filename;
            }
            return filename;
        },
        getAllNodesPathType(res) {
            if (res != undefined) {
                for (var i = 0; i < res.length; i++) {
                    res[i].formUrl = this.getFilePath(res[i]);
                }
                return res;
            }
        },
        //对选中数据进行判断，若父亲已勾选则子节点无需再加入，遍历已选择数据的children,若children==已选中的数组，将该数据删除;
        deleteFatherChildren(res) {
            var allArr = Object.assign([], res);
            for (let i = 0; i < res.length; i++) {
                if (res[i].children) {
                    for (let j = 0; j < res[i].children.length; j++) {
                        for (let k = 0; k < allArr.length; k++) {
                            if (res[i].children[j] == allArr[k]) {
                                allArr.splice(k, 1);
                                break;
                            }
                        }

                    }
                }
            }
            return allArr;
        },
        matchfileType(fileName) {
            return commonUtils.matchfileTypes(fileName);
        },
        matchfolderType(docType) {
            return docType?docType=='ALBUM'?'album':'folder':'folder';
        },
    },
    filters: {
        ellipsis(value) {
            if (!value) return '';
            if (value.length > 37) {
                return value.slice(0, 37) + '...';
            }
            return value;
        }
    }
};
//遍历看点击的节点是否存在子节点,并把子节点的ID装入数组
function traverseTree(node) {
    let child = node.children,
        arr = [];
    arr.push(node.keyId);
    if (child) {
        child.forEach(function (node) {
            arr = arr.concat(traverseTree(node));
        });
    }
    return arr;
}
</script>

<style>
[v-cloak] {
  display: none;
}
#sourceSelect .el-tree__empty-text {
    display: none;
}

.el-scrollbar .el-scrollbar__wrap {
    overflow-x: hidden;
}

.el-tree>.el-tree-node {
    display: inline-block;
    min-width: 100%;
}

.el-tree-node__content {
    height: 40px !important;
    /*no*/
    position: relative;
    font-size: 16px;
    /*no*/
    min-width: 430px;
    /*no*/
}

.el-tree {
    padding-left: 10px;
    /*no*/
}

.el-tree-node__label {
    font-size: 16px;
    /*no*/

}

.el-tree-node:focus>.el-tree-node__content {
    background-color: #ebf3fe !important;
}

.el-tree .el-tree-node__expand-icon.expanded {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
}

.el-tree .el-icon-caret-right:before {
    background: url("../../../assets/images/workspace/icon_util.png");
    content: "";
    display: block;
    width: 16px;
    /*no*/
    height: 20px;
    /*no*/
    background-position: -875px -248px;
    /*no*/
}

.el-tree .el-tree-node__expand-icon.expanded.el-icon-caret-right:before {
    background: url("../../../assets/images/workspace/icon_util.png");
    content: "";
    display: block;
    width: 16px;
    /*no*/
    height: 20px;
    /*no*/
    background-position: -875px -248px;
    /*no*/
    transform: rotate(90deg);
    /*no*/
    position: relative;
    left: -3px;
    /*no*/
}

.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #4181ff;
    border-color: #4181ff;
}

.el-checkbox__input.is-checked+.el-checkbox__label {
    color: #4181ff;
}

.el-checkbox.is-bordered.is-checked {
    border-color: #4181ff;
}

.el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #4181ff;
}

#transferMulti .el-checkbox__inner {
    border-radius: 0px !important;
    /*no*/
    width: 15px !important;
    /*no*/
    height: 15px !important;
    /*no*/
    border: 1px solid #4181ff !important;
    /*no*/
    position: absolute;
    top: -5.5px;
    /*no*/
    bottom: 0;
    margin: auto;
}
 .el-checkbox__inner::after {
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
    content: "";
    border: 2px solid #fff !important;
    /*no*/
    border-left: 0 !important;
    border-top: 0 !important;
    height: 11px !important;
    /*no*/
    width: 4.3px !important;
    /*no*/
    left: 4px !important;
    /*no*/
    position: absolute;
    top: -1.5px !important;
    /*no*/
    -webkit-transform: rotate(45deg) scaleY(0);
    transform: rotate(45deg) scaleY(0);
    -webkit-transition: -webkit-transform 0.05s ease-in 0.05s !important;
    transition: -webkit-transform 0.05s ease-in 0.05s !important;
    transition: transform 0.05s ease-in 0.05s !important;
    transition: transform 0.05s ease-in 0.05s,
        -webkit-transform 0.05s ease-in 0.05s !important;
    transition: transform 0.05s ease-in 0.05s,
        -webkit-transform 0.05s ease-in 0.05s !important;
    -webkit-transform-origin: center;
    transform-origin: center;
    text-shadow: 0 0 black;
}

.tree-icon-position {
    margin: 0px 10px 0 0px;
    /*no*/
    float: left;
}

.node-name {
    display: block;
}

.is-leaf.el-tree-node__expand-icon.el-icon-caret-right:before {
    width: 16px;
    /*no*/
    height: 20px;
    /*no*/
    content: "" !important;
    background: none !important;
}

.drive-option-icon {
    float: left;
    position: relative;
    top: -2px;
    /*no*/
}

.folder-option-icon {
    float: left;
}

.tr-tree-node-name {
    max-width: 320px;
    /*no*/
    float: left;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}

#tree-app .el-icon-loading {
    width: 16px;
    /*no*/
    height: 16px;
    /*no*/
    border: 0.5px solid #5562b4;
    /*no*/
    border-left-color: #5562b4;
    border-right-color: #f0f7ff;
    border-top-color: #f0f7ff;
    border-radius: 50%;
    /*圆角*/
    animation: rotating 0.1s linear ease-in-out infinite;

}

#tree-app .el-icon-loading:before {
    content: '';
}

#tree-app .el-tree-node__loading-icon {
    margin-right: 5Px;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/cloud_transfer_popups/transfer_multi_popup.vue